import Model from 'flarum/common/Model';
export default class Society extends Model {
  groupId() {
    return Model.attribute('groupId').call(this);
  }
  name() {
    return Model.attribute('name').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }

  // Cartothèque card print-layout configuration - see CardLayoutEditor
  // and the backend's CardPdfBuilder for how these get consumed.
  cardWidth() {
    return Model.attribute('cardWidth').call(this);
  }
  cardHeight() {
    return Model.attribute('cardHeight').call(this);
  }
  cardSocietyName() {
    return Model.attribute('cardSocietyName').call(this);
  }
  cardSocietyNameX() {
    return Model.attribute('cardSocietyNameX').call(this);
  }
  cardSocietyNameY() {
    return Model.attribute('cardSocietyNameY').call(this);
  }
  cardSocietyNameSize() {
    return Model.attribute('cardSocietyNameSize').call(this);
  }
  cardSocietyNameFont() {
    return Model.attribute('cardSocietyNameFont').call(this);
  }
  cardSocietyNameFontStyle() {
    return Model.attribute('cardSocietyNameFontStyle').call(this);
  }
  cardLogoUrl() {
    return Model.attribute('cardLogoUrl').call(this);
  }
  cardLogoWidth() {
    return Model.attribute('cardLogoWidth').call(this);
  }
  cardLogoHeight() {
    return Model.attribute('cardLogoHeight').call(this);
  }
  cardLogoX() {
    return Model.attribute('cardLogoX').call(this);
  }
  cardLogoY() {
    return Model.attribute('cardLogoY').call(this);
  }
  cardShowFamily() {
    return Model.attribute('cardShowFamily').call(this);
  }
  cardFamilyX() {
    return Model.attribute('cardFamilyX').call(this);
  }
  cardFamilyY() {
    return Model.attribute('cardFamilyY').call(this);
  }
  cardFamilySize() {
    return Model.attribute('cardFamilySize').call(this);
  }
  cardFamilyFont() {
    return Model.attribute('cardFamilyFont').call(this);
  }
  cardFamilyFontStyle() {
    return Model.attribute('cardFamilyFontStyle').call(this);
  }
  cardSplitCanonicalName() {
    return Model.attribute('cardSplitCanonicalName').call(this);
  }
  cardCanonicalNameX() {
    return Model.attribute('cardCanonicalNameX').call(this);
  }
  cardCanonicalNameY() {
    return Model.attribute('cardCanonicalNameY').call(this);
  }
  cardCanonicalNameSize() {
    return Model.attribute('cardCanonicalNameSize').call(this);
  }
  cardCanonicalNameFont() {
    return Model.attribute('cardCanonicalNameFont').call(this);
  }
  cardCanonicalNameFontStyle() {
    return Model.attribute('cardCanonicalNameFontStyle').call(this);
  }
  cardAuthorX() {
    return Model.attribute('cardAuthorX').call(this);
  }
  cardAuthorY() {
    return Model.attribute('cardAuthorY').call(this);
  }
  cardAuthorSize() {
    return Model.attribute('cardAuthorSize').call(this);
  }
  cardAuthorFont() {
    return Model.attribute('cardAuthorFont').call(this);
  }
  cardAuthorFontStyle() {
    return Model.attribute('cardAuthorFontStyle').call(this);
  }
  cardShowSynonym() {
    return Model.attribute('cardShowSynonym').call(this);
  }
  cardSynonymX() {
    return Model.attribute('cardSynonymX').call(this);
  }
  cardSynonymY() {
    return Model.attribute('cardSynonymY').call(this);
  }
  cardSynonymSize() {
    return Model.attribute('cardSynonymSize').call(this);
  }
  cardSynonymFont() {
    return Model.attribute('cardSynonymFont').call(this);
  }
  cardSynonymFontStyle() {
    return Model.attribute('cardSynonymFontStyle').call(this);
  }
  cardVernacularNameX() {
    return Model.attribute('cardVernacularNameX').call(this);
  }
  cardVernacularNameY() {
    return Model.attribute('cardVernacularNameY').call(this);
  }
  cardVernacularNameSize() {
    return Model.attribute('cardVernacularNameSize').call(this);
  }
  cardVernacularNameFont() {
    return Model.attribute('cardVernacularNameFont').call(this);
  }
  cardVernacularNameFontStyle() {
    return Model.attribute('cardVernacularNameFontStyle').call(this);
  }
  cardShowToxicityText() {
    return Model.attribute('cardShowToxicityText').call(this);
  }
  cardToxicityTextX() {
    return Model.attribute('cardToxicityTextX').call(this);
  }
  cardToxicityTextY() {
    return Model.attribute('cardToxicityTextY').call(this);
  }
  cardToxicityTextSize() {
    return Model.attribute('cardToxicityTextSize').call(this);
  }
  cardToxicityTextFont() {
    return Model.attribute('cardToxicityTextFont').call(this);
  }
  cardToxicityTextFontStyle() {
    return Model.attribute('cardToxicityTextFontStyle').call(this);
  }
  cardShowToxicityLogo() {
    return Model.attribute('cardShowToxicityLogo').call(this);
  }
  cardToxicityLogoWidth() {
    return Model.attribute('cardToxicityLogoWidth').call(this);
  }
  cardToxicityLogoHeight() {
    return Model.attribute('cardToxicityLogoHeight').call(this);
  }
  cardToxicityLogoX() {
    return Model.attribute('cardToxicityLogoX').call(this);
  }
  cardToxicityLogoY() {
    return Model.attribute('cardToxicityLogoY').call(this);
  }
  cardShowQrCode() {
    return Model.attribute('cardShowQrCode').call(this);
  }
  cardQrCodeSize() {
    return Model.attribute('cardQrCodeSize').call(this);
  }
  cardQrCodeX() {
    return Model.attribute('cardQrCodeX').call(this);
  }
  cardQrCodeY() {
    return Model.attribute('cardQrCodeY').call(this);
  }
  cardQrCodeHides() {
    return Model.attribute('cardQrCodeHides').call(this);
  }
  cardWithNo() {
    return Model.attribute('cardWithNo').call(this);
  }
  cardShowPhylum() {
    return Model.attribute('cardShowPhylum').call(this);
  }
  cardPhylumX() {
    return Model.attribute('cardPhylumX').call(this);
  }
  cardPhylumY() {
    return Model.attribute('cardPhylumY').call(this);
  }
  cardPhylumSize() {
    return Model.attribute('cardPhylumSize').call(this);
  }
  cardPhylumFont() {
    return Model.attribute('cardPhylumFont').call(this);
  }
  cardPhylumFontStyle() {
    return Model.attribute('cardPhylumFontStyle').call(this);
  }

  // The cartothèque ordered by phylum then scientific name rather than by
  // number - on screen (CartothequePage), in its exports and printed cards
  // (see the backend's CartothequeOrder).
  cartothequeSortByPhylum() {
    return Model.attribute('cartothequeSortByPhylum').call(this);
  }

  // Comma-separated origins allowed to read this société's own public
  // exhibitions/findings cross-origin (see AllowCorsForPublicExhibitions,
  // the backend's own docblock explains the null-means-unrestricted
  // default) - edited in SocietyPage.js's own "Partage externe" section.
  allowedOrigins() {
    return Model.attribute('allowedOrigins').call(this);
  }

  // Whether a guest (not logged in) can read this société's own
  // exhibitions/findings at all - see ExhibitionResource's own scope().
  // true (every société by default) matches this whole feature's prior
  // "publique uniquement en get" decision - doesn't affect a logged-in
  // forum member either way.
  isPublic() {
    return Model.attribute('isPublic').call(this);
  }
}
flarum.reg.add('champis-exhibitions', 'common/models/Society', Society);